import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { Table, Form, Button } from '_zari/core'

import ActualizarComentarioModal from './modals/actualizarComentario'
import StockSedesModal from './modals/stocksSedes'

const FilaDetalleTemplate = ({
  index,
  row,
  idSocio,
  actualizarFilaHandler,
  actualizarComentarioHandler,
  eliminarFilaHandler
}) => {
  const __adminContext = React.useContext(AdminContext)

  const [cantidad, setCantidad] = React.useState(row.cantidad || '')
  const [precio, setPrecio] = React.useState(row.precio || '')
  const [tipoInputCantidad, setTipoInputCantidad] = React.useState(row.tipoInputCantidad || 'select')

  const [mostrarActualizarComentarioModal, setMostrarActualizarComentarioModal] = React.useState(false)
  const [mostrarStockSedesModal, setMostrarStockSedesModal] = React.useState(false)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      saltarCampo = true

      // if (__adminContext.valoresConfiguracionUsuario.permisoVentas_Precio) {
      __focusPrecio = true
      // } else {
      // saltarFila = true
      // }
    }
    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const changePrecioHandler = e => {
    const keyCode = e.keyCode
    const selectedValue = e.target.value

    let __focusCantidad = false
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    const selectedPrecio = row.precios.filter(x => x._id === selectedValue)[0]
    let _idProductoPresentacionPrecio = selectedPrecio._id
    let precio = selectedPrecio.precio

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }

    actualizarFilaHandler({
      ...row,
      tipoInputCantidad,
      cantidad,
      _idProductoPresentacionPrecio,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyUpPrecioSelectHandler = e => {
    const keyCode = e.keyCode

    if (keyCode === 13 || keyCode === 9) {
      let __focusPrecio = false
      let __focusPlaca = false
      let saltarFila = true
      let saltarCampo = true

      if (__adminContext.valoresConfiguracionCompania.flagGrifo && idSocio) {
        __focusPrecio = false
        __focusPlaca = true
        saltarFila = false
        saltarCampo = true
      }

      actualizarFilaHandler({
        ...row,
        __focusPrecio,
        __focusPlaca,
        saltarFila,
        saltarCampo
      })
    }
  }

  const keyUpPrecioInputHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = false
    let __focusPrecio = true
    let __focusDescuento = false
    let __focusPlaca = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      if (__adminContext.valoresConfiguracionCompania.flagGrifo && idSocio) {
        __focusPrecio = false
        __focusPlaca = true
        saltarFila = false
        saltarCampo = true
      } else {
        __focusPrecio = false
        saltarFila = true
        saltarCampo = true
      }
    }

    actualizarFilaHandler({
      ...row,
      tipoInputCantidad,
      cantidad,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      __focusPlaca,
      saltarFila,
      saltarCampo
    })
  }

  const clickCambiarInputASelect = () => {
    let __focusCantidad = false
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    const selectedPrecio = row.precios[0]
    let _idProductoPresentacionPrecio = selectedPrecio._id
    let precio = selectedPrecio.precio

    setTipoInputCantidad('select')

    actualizarFilaHandler({
      ...row,
      tipoInputCantidad: 'select',
      cantidad,
      _idProductoPresentacionPrecio,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownPrecioHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const clickActualizarComentarioHandler = () => {
    window.setTimeout(() => {
      setMostrarActualizarComentarioModal(true)
    }, 150)
  }

  const actualizarComentarioInnerHandler = ({ comentario }) => {
    setMostrarActualizarComentarioModal(false)
    actualizarComentarioHandler({
      ...row,
      comentario
    })
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (!row.flagAnticipo && !row.flagCodigoBarra) {
      if (row.__filaActiva && row.__focusCantidad) {
        window.setTimeout(() => {
          inputCantidadRef.current.select()
        }, 250)
      }
    }
  }, [row.__filaActiva, row.__focusCantidad, row.flagAnticipo, row.flagCodigoBarra])

  const inputPrecioRef = React.useRef()
  React.useEffect(() => {
    if (row.flagAnticipo && !row.flagCodigoBarra) {
      if (row.__filaActiva && row.__focusCantidad) {
        window.setTimeout(() => {
          inputPrecioRef.current.select()
        }, 250)
      }
    }
  }, [row.__filaActiva, row.__focusCantidad, row.flagAnticipo, row.flagCodigoBarra])

  return (
    <>
      <tr>
        <td className='text-center'>{parseFloat(index) + 1}</td>
        <td className='text-center'>{row.codigoProducto || '--'}</td>
        <td>
          {row.nombreProducto || '--'} {row.flagPromocionOrigen ? '(PROMO)' : ''}
        </td>
        <td>
          <Form.InputText
            ref={inputCantidadRef}
            className='text-center'
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        <td className='text-center'>{row.nombreUnidadDeMedida || '--'}</td>
        {/* {__adminContext.valoresConfiguracionUsuario.permisoVentas_Precio ? ( */}
        <td>
          <>
            {row.flagAnticipo ||
            (row.precios && row.precios.length === 1) ||
            (row.precios && row.precios.length === 0) ||
            tipoInputCantidad === 'text' ? (
              <>
                <Form.InputGroup>
                  <Form.InputText
                    ref={inputPrecioRef}
                    className='text-center'
                    value={precio}
                    autoFocus={row.__filaActiva && row.__focusPrecio}
                    onChange={e => setPrecio(e.target.value)}
                    onKeyUp={keyUpPrecioInputHandler}
                    onKeyDown={keyDownPrecioHandler}
                  />
                  {row.precios && row.precios.length > 1 && (
                    <Form.InputGroup.Append>
                      <Button onClick={clickCambiarInputASelect} tiny>
                        o
                      </Button>
                    </Form.InputGroup.Append>
                  )}
                </Form.InputGroup>
              </>
            ) : (
              <>
                <Form.InputGroup>
                  <Form.Select
                    value={row._idProductoPresentacionPrecio}
                    onChange={e => changePrecioHandler(e)}
                    autoFocus={row.__filaActiva && row.__focusPrecio}
                    onKeyUp={keyUpPrecioSelectHandler}
                    onKeyDown={keyDownPrecioHandler}
                  >
                    {row.precios.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.precio} ({val.precioListaNombre})
                      </option>
                    ))}
                  </Form.Select>
                  <Form.InputGroup.Append>
                    <Button onClick={() => setTipoInputCantidad('text')} tiny>
                      o
                    </Button>
                  </Form.InputGroup.Append>
                </Form.InputGroup>
              </>
            )}
          </>
        </td>
        <td className='text-center'>{row.total || '0.00'}</td>
        <td>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='historial-stocks-sedes'
                handleClose={handleClose}
                onClick={w => setMostrarStockSedesModal(true)}
              >
                Ver Stocks
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item
                key='comentario'
                handleClose={handleClose}
                onClick={clickActualizarComentarioHandler}
              >
                Comentario
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminarFilaHandler}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </td>
      </tr>
      {mostrarActualizarComentarioModal && (
        <ActualizarComentarioModal
          handleClose={e => setMostrarActualizarComentarioModal(false)}
          show={mostrarActualizarComentarioModal}
          modalData={row}
          actualizarComentarioHandler={actualizarComentarioInnerHandler}
        />
      )}
      {mostrarStockSedesModal && (
        <StockSedesModal
          handleClose={e => setMostrarStockSedesModal(false)}
          show={mostrarStockSedesModal}
          idProductoPresentacion={row._idProductoPresentacion}
        />
      )}
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
